import { CSSProperties } from "react";

import { BannerCtaConfig } from "./types";

type MappedCtaStyle = {
  className: string;
  style?: CSSProperties;
};

type MappedCtaPosition = {
  className: string;
  style?: CSSProperties;
};

export const mapCtaStyle = (ctaConfig?: BannerCtaConfig): MappedCtaStyle => {
  const preset = ctaConfig?.stylePreset ?? "primary";
  const presetClassNameMap: Record<NonNullable<BannerCtaConfig["stylePreset"]>, string> = {
    primary: "bg-primary text-white hover:bg-primary/90",
    secondary: "bg-white text-black hover:bg-white/90",
    dark: "bg-black text-white hover:bg-black/90",
    light: "bg-white text-black hover:bg-white/90",
    custom: "",
  };

  const customStyle = ctaConfig?.customStyle;
  const style: CSSProperties | undefined =
    preset === "custom" && customStyle
      ? {
          backgroundColor: customStyle.bgColor,
          color: customStyle.textColor,
          borderRadius: typeof customStyle.borderRadiusPx === "number" ? `${customStyle.borderRadiusPx}px` : undefined,
          paddingLeft: typeof customStyle.paddingX === "number" ? `${customStyle.paddingX}px` : undefined,
          paddingRight: typeof customStyle.paddingX === "number" ? `${customStyle.paddingX}px` : undefined,
          paddingTop: typeof customStyle.paddingY === "number" ? `${customStyle.paddingY}px` : undefined,
          paddingBottom: typeof customStyle.paddingY === "number" ? `${customStyle.paddingY}px` : undefined,
          fontSize: typeof customStyle.fontSizePx === "number" ? `${customStyle.fontSizePx}px` : undefined,
        }
      : undefined;

  return {
    className: presetClassNameMap[preset],
    style,
  };
};

export const mapCtaPosition = (ctaConfig?: BannerCtaConfig, isRTL?: boolean): MappedCtaPosition => {
  const preset = ctaConfig?.positionPreset ?? "center_bottom";

  const presetClassNameMap: Record<NonNullable<BannerCtaConfig["positionPreset"]>, string> = {
    center_bottom: "left-1/2 bottom-3 -translate-x-1/2",
    // right_middle: isRTL ? "left-3 top-1/2 -translate-y-1/2" : "right-3 top-1/2 -translate-y-1/2",
    // left_middle: isRTL ? "right-3 top-1/2 -translate-y-1/2" : "left-3 top-1/2 -translate-y-1/2",
    right_middle: "right-3 top-1/2 -translate-y-1/2",
    left_middle: "left-3 top-1/2 -translate-y-1/2",
    custom: "",
  };

  const customPosition = ctaConfig?.customPosition;
  const style: CSSProperties | undefined =
    preset === "custom" && customPosition
      ? {
          top: customPosition.top,
          right: customPosition.right,
          bottom: customPosition.bottom,
          left: customPosition.left,
          transform: [
            customPosition.translateX ? `translateX(${customPosition.translateX})` : null,
            customPosition.translateY ? `translateY(${customPosition.translateY})` : null,
          ]
            .filter(Boolean)
            .join(" "),
        }
      : undefined;

  return {
    className: presetClassNameMap[preset],
    style,
  };
};
